import type {
  U_CLIENT_RECORDS_COST,
  U_COUNT_CLIENT_RECORDS,
  U_COUNT_CLIENT_REPLIES,
  U_INSTAGRAM,
  IS_DELETED,
  U_QUANTITY_IN_BRANCH,
  U_RECEIVERS_COUNT,
  U_SENDOUT_CONVERSION,
  U_SENT_COUNT,
  U_START_DATE,
  U_VERSION_FRONTEND,
  ACTIONS,
  AVATAR,
  CONTACTS,
  KEY,
  LAST_VISIT,
  NAME,
  RIGHTS,
  U_ACTION,
  U_AVERAGE_CHECK,
  U_AVERAGE_CHECK_1,
  U_BALANCE,
  U_BRANCH,
  U_CATEGORY,
  U_CITY,
  U_CLIENT,
  U_CLIENT_SERVICES,
  U_COMMENT,
  U_COUNT_CONSTANTS_PAYMENTS,
  U_COUNT_VISITS,
  U_CREATE_USER,
  U_DATE_VISIT_FIRST,
  U_DATE_VISIT_LAST,
  U_DESCRIPTION,
  U_DETAILS,
  U_DURATION,
  U_EMPLOYEE,
  U_EMPLOYEES,
  U_EXECUTION_DATE,
  U_FOR_A_PERIOD,
  U_IN_PROGRESS,
  U_INTEGRATIONS,
  U_IS_DEFAULT,
  U_KEY,
  U_KPP,
  U_LAG,
  U_LEGAL_ENTITY,
  U_LOGIN,
  U_LOYALTY_CARD,
  U_MONEY_SPENT,
  U_NAME,
  U_OPERATIONS,
  U_OWNER,
  U_PAY_TYPE,
  U_PERFORMANCE,
  U_PHONE,
  U_POSITION,
  U_PRICE,
  U_QUANTITY,
  U_QUANTITY_1,
  U_ROLES,
  U_SCHEDULE,
  U_SERVICES,
  U_SHARE_OF_TOTAL_AMOUNT,
  U_STATUS,
  U_SUCCESS,
  U_SUM,
  U_TASK,
  U_TASK_TYPE,
  U_TAX_PAYER_ID,
  U_TIME,
  U_UNSUCCESSFUL,
  U_USER,
  U_VISIT_FREQUENCY,
} from '@app/constants';
import type { NClients, NSmallGlobalEntities } from '@app/types';

export namespace NTables {
  export type Users = {
    [KEY]: string;
    [AVATAR]: JSX.Element;
    [NAME]: JSX.Element;
    [CONTACTS]: JSX.Element;
    [RIGHTS]: JSX.Element;
    [LAST_VISIT]: JSX.Element;
    [ACTIONS]: JSX.Element;
  };

  export type ClientsMain = (props: {
    loader: boolean;
    data: NClients.ModelClientLite[];
    rowSelection: {
      onChange: (
        selectedRowKeys: React.Key[],
        selectedRows: NTables.ClientsHeader[]
      ) => void;
    };
    rowsPerPage: number;
    totalRowsCount: number;
    hasRightToEdit: boolean;
    handlePageChange: (page: number, _: number) => void;
    handleEdit: (value: NClients.ClientFull['Id']) => void;
    isMobile: boolean;
    isStartedPackData: boolean;
    pageNumber: number;
    hasUserRightToCommunicate: boolean;
  }) => JSX.Element;

  export type Client = {
    [U_KEY]: string;
    [U_NAME]: string;
    [U_PHONE]: string;
    [U_ACTION]: JSX.Element;
  };

  export type ClientsHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_PHONE]: NSmallGlobalEntities.Phone;
    [U_BALANCE]: string;
    [U_MONEY_SPENT]: string;
    [U_COUNT_VISITS]: number;
    [U_DATE_VISIT_LAST]: string;
    [U_DATE_VISIT_FIRST]: string;
    [U_VISIT_FREQUENCY]: JSX.Element;
    [U_LOYALTY_CARD]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type TagsHeader = {
    [KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_DESCRIPTION]: JSX.Element;
    [U_ACTION]: JSX.Element;
    isDeleted: boolean;
  };

  export type EmployeesHeader = {
    [KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_SERVICES]: JSX.Element;
    [U_SCHEDULE]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type PositionsHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_DESCRIPTION]: JSX.Element;
    [U_ROLES]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type ClientServicesHeader = {
    [U_KEY]: React.Key;
    [U_CATEGORY]: JSX.Element;
    [U_NAME]: JSX.Element;
    [U_PRICE]: JSX.Element;
    [U_DURATION]: string;
    [U_EMPLOYEES]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type RecordsServiceHeader = {
    [U_KEY]: React.Key;
    [U_TIME]: JSX.Element;
    [U_EMPLOYEE]: JSX.Element;
    [U_CLIENT_SERVICES]: JSX.Element;
    [U_CLIENT]: JSX.Element;
    [U_CREATE_USER]: JSX.Element;
    [U_STATUS]: JSX.Element;
  };

  export type RecordsTagsHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_DESCRIPTION]: JSX.Element;
  };

  export type EmployeesClientServicesHeader = {
    [U_KEY]: React.Key;
    [U_CATEGORY]: JSX.Element;
    [U_NAME]: JSX.Element;
    [U_DURATION]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type SortEmployeesHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_POSITION]: JSX.Element;
    // [U_CLIENT_SERVICES]: string;
  };

  export type LegalEntitiesHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_TAX_PAYER_ID]: JSX.Element;
    [U_KPP]: JSX.Element;
    [U_DESCRIPTION]: JSX.Element;
    [U_COUNT_CONSTANTS_PAYMENTS]: JSX.Element;
    [U_ACTION]: JSX.Element;
    [IS_DELETED]: boolean;
  };

  export type PaymentsAccountHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_IS_DEFAULT]: JSX.Element;
    [U_LEGAL_ENTITY]: JSX.Element;
    [U_PAY_TYPE]: JSX.Element;
    [U_BALANCE]: JSX.Element;
    [U_DESCRIPTION]: JSX.Element;
    [U_ACTION]: JSX.Element;
    [IS_DELETED]: boolean;
  };

  export type Integrations = {
    [U_KEY]: React.Key;
    [U_INTEGRATIONS]: JSX.Element;
    [U_LOGIN]: JSX.Element;
    [U_STATUS]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type ClientPayments = {
    [U_KEY]: React.Key;
    [U_OPERATIONS]: JSX.Element;
    [U_SUM]: JSX.Element;
    [U_CLIENT]: JSX.Element;
    [U_USER]: JSX.Element;
    [U_DETAILS]: JSX.Element;
    [U_COMMENT]: JSX.Element;
  };

  export type DirectionIndicators = {
    [U_KEY]: React.Key;
    [U_SUM]: JSX.Element;
    [U_SHARE_OF_TOTAL_AMOUNT]: JSX.Element;
    [U_FOR_A_PERIOD]: JSX.Element;
    [U_PERFORMANCE]: JSX.Element;
    [U_LAG]: JSX.Element;
    [U_QUANTITY]: JSX.Element;
    [U_QUANTITY_IN_BRANCH]: JSX.Element;
    [U_AVERAGE_CHECK]: JSX.Element;
    [U_QUANTITY_1]: JSX.Element;
    [U_AVERAGE_CHECK_1]: JSX.Element;
    // Скрыто в рамках таски task/5716. Оставляю на случай, если нужно будет вернуть
    // [U_QUANTITY_2]: JSX.Element;
    // [U_AMOUNT]: JSX.Element;
    // [U_QUANTITY_3]: JSX.Element;
    // [U_AMOUNT_1]: JSX.Element;
  };

  export type TaskListHeader = {
    [U_KEY]: React.Key;
    [U_EXECUTION_DATE]: JSX.Element;
    [U_CLIENT]: JSX.Element;
    [U_TASK_TYPE]: JSX.Element;
    [U_TASK]: JSX.Element;
    [U_STATUS]: JSX.Element;
    [ACTIONS]: JSX.Element;
  };

  export type SalesFunnelsHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_IN_PROGRESS]: JSX.Element;
    [U_SUCCESS]: JSX.Element;
    [U_UNSUCCESSFUL]: JSX.Element;
    [ACTIONS]: JSX.Element;
  };

  export type OrganizationsHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_CITY]: JSX.Element;
    [U_BRANCH]: JSX.Element;
    [U_OWNER]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type SendoutsHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_INTEGRATIONS]: JSX.Element;
    [U_START_DATE]: JSX.Element;
    [U_RECEIVERS_COUNT]: JSX.Element;
    [U_SENT_COUNT]: JSX.Element;
    [U_COUNT_CLIENT_REPLIES]: JSX.Element;
    [U_COUNT_CLIENT_RECORDS]: JSX.Element;
    [U_SENDOUT_CONVERSION]: JSX.Element;
    [U_CLIENT_RECORDS_COST]: JSX.Element;
    [U_STATUS]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type SendoutReceiversHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_PHONE]: JSX.Element;
    [U_INSTAGRAM]: JSX.Element;
    [U_INTEGRATIONS]: JSX.Element;
    [U_STATUS]: JSX.Element;
    [U_TIME]: JSX.Element;
    [U_ACTION]: JSX.Element;
  };

  export type OrganizationUsersHeader = {
    [U_KEY]: React.Key;
    [U_NAME]: JSX.Element;
    [U_PHONE]: JSX.Element;
    [U_BRANCH]: JSX.Element;
    [LAST_VISIT]: JSX.Element;
    [U_VERSION_FRONTEND]: JSX.Element;
  };

  export type LogsRegistryTableHeader = {
    [U_KEY]: React.Key;
    [U_DESCRIPTION]: JSX.Element;
    [U_TIME]: string;
  };
}
